/* eslint-disable eqeqeq */
import React, { FC } from "react";
import { Box } from "../../../../../components/box";
import { Col, Row } from "react-bootstrap";
import { Input } from "antd";
import { StyledTitle } from "../../../../../components/styled-antd/Title";
import { getERequestStatus } from "../../../human-organization/summary-employee-request/utils/get-status";
import { requestStatus } from "../../../../../constants";
import { useSoftwares } from "../../../../../hook";
import { SystemCode } from "../../../../../constants";
import { useSelector } from "../../../../../store/store";

export const RecallToolEvalate: FC<{
  setInspectionUnit: any;
  setEvaluation: any;
  inspectionUnit: any;
  evaluation: any;
  getNextStep: number;
  detail: any;
}> = ({
  setInspectionUnit,
  setEvaluation,
  inspectionUnit,
  evaluation,
  getNextStep,
  detail,
}) => {
  const eRequestStatus = getERequestStatus(detail);

  const { getITLeadITHeadAssignee } = useSoftwares();
  const user = useSelector((state) => state.user);
  const currentUserName = user?.current?.username.toLowerCase();

  return (
    <>
      {getNextStep != 1 && (
        <Box title="Đánh giá tình trạng kỹ thuật">
          <Row>
            <Col sm="12" md="12">
              <StyledTitle level={5}>
                Đơn vị kiểm tra tình trạng kỹ thuật{" "}
                <span className="text-danger">(*)</span>
              </StyledTitle>
              <Input
                value={inspectionUnit}
                onChange={(value) => {
                  setInspectionUnit(value?.target?.value);
                }}
                disabled={
                  getNextStep === 3 ||
                  getNextStep === 4 ||
                  currentUserName != getITLeadITHeadAssignee(SystemCode.ETR).eApprovedByITLead.split("|")[0]||
                  [requestStatus.rejected, requestStatus.completed].includes(
                    eRequestStatus
                  )
                }
              />
            </Col>

            <Col sm="12" md="12">
              <StyledTitle level={5}>
                Đánh giá <span className="text-danger">(*)</span>
              </StyledTitle>
              <Input
                value={evaluation}
                onChange={(value) => {
                  setEvaluation(value?.target?.value);
                }}
                disabled={
                  getNextStep === 3 ||
                  getNextStep === 4 ||
                  currentUserName != getITLeadITHeadAssignee(SystemCode.ETR).eApprovedByITLead.split("|")[0]||
                  [requestStatus.rejected, requestStatus.completed].includes(
                    eRequestStatus
                  )
                }
              />
            </Col>
          </Row>
        </Box>
      )}
    </>
  );
};
